import { useEffect } from 'react';
import { WifiOff } from 'lucide-react';
import { useOnline } from '@/lib/offline/useOnline';
import { flushPhotoQueue } from '@/lib/offline/photoQueue';
import { readServerClock } from '@/lib/offline/serverClock';

/**
 * "No connection" strip. On (re)connect: flush queued photos (Firestore writes sync by
 * themselves) and re-measure the server clock offset.
 */
export function OfflineBanner() {
  const online = useOnline();

  useEffect(() => {
    if (!online) return;
    void flushPhotoQueue();
    // Fresh clock offset for the next offline check-in.
    void readServerClock();
  }, [online]);

  if (online) return null;
  return (
    <div className="bg-warn-soft text-warn rounded-control mb-3 flex items-center gap-2 px-3 py-2 text-sm font-semibold">
      <WifiOff className="h-4 w-4 flex-shrink-0" />
      אין חיבור לאינטרנט — הדיווחים נשמרים ויישלחו כשהחיבור יחזור
    </div>
  );
}
